import { InjectionToken } from '@angular/core';

export const HDTicketTypesToken = new InjectionToken('HDTicketTypesToken');
